query AnalyticsUsersByCountry(
  $filter: AnalyticsUsersFilterInput!
  $limit: Int
) {
  analyticsUsers(filter: $filter) {
    usersByCountry(limit: $limit) {
      countryCode
      users
    }
  }
}
